import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './FieldTip.scss';

export default function FieldTip({ className, title, children, ...props }) {
    const { t } = useTranslation();
    const tipTitle = title ? title : t('FieldTip.defaultLabel');

    return (
        <div className={cn(styles.root, className)} {...props}>
            <div className={styles.title}>
                <span>{tipTitle}</span>
            </div>
            <div dangerouslySetInnerHTML={{ __html: children }} />
        </div>
    );
}

FieldTip.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.any.isRequired,
};

FieldTip.defaultProps = {
    className: '',
};
